<fc-general-modal [baseId]="baseId" [form]="form" [fcModalItemContext]="fcModalItemContext" (saveForm)="save()" (cancelForm)="onCancel()">
  <div [formGroup]="form">
    <div class="flex-row-generic">
      <!-- External Id Control -->
      <div class="flex-item-two-columns">
        <div class="form-group">
          <label for="{{ baseId }}-id" translate>ID</label>
          <input
            id="{{ baseId }}-id"
            class="form-control"
            [ngClass]="{ error: showErrors(externalIdControl, isSubmitted),'required': isRequired(externalIdControl) }"
            type="text"
            [maxlength]="fcListValidation.validations.ExternalID.MaxLength"
            formControlName="externalId"
          />
          <div
            *ngIf="showErrors(externalIdControl, isSubmitted)"
            id="{{ baseId }}-warning-text-external-id"
            class="incorrect-input"
            translate
          >
            {{ externalIdControl.errors | fcListValidation : 'External Id' }}
          </div>
        </div>
      </div>
      <!-- External Id Control -->

      <!-- Text Color Control -->
      <div class="form-group flex-item-two-columns">
          <ap-fc-text-color-list
            [baseId]="baseId"
            [form]="form"
            [textColorControl]="nameControl"
            [textColorValue]="nameControl.value"
            [color]="colorControl.value"
          >
          </ap-fc-text-color-list>
      </div>
      <!-- Text Color Control -->
    </div>

    <!-- Name Control -->
    <div class="form-group">
      <label for="{{ baseId }}-name" translate>Name</label>
      <div class="dropdown">
        <input
          id="{{ baseId }}-name"
          class="form-control"
          [ngClass]="{ error: showErrors(nameControl, isSubmitted), 'required': isRequired(nameControl) }"
          type="text"
          [maxlength]="fcListValidation.validations.Name.MaxLength"
          formControlName="name"
        />
      </div>
      <div *ngIf="showErrors(nameControl, isSubmitted)" class="incorrect-input" id="{{ baseId }}-warning-text-name" translate>
        {{ nameControl.errors | fcListValidation : 'Name' }}
      </div>
    </div>
    <!-- Name Control -->

    <!-- Notes Control -->
    <div class="form-group full-control">
      <label for="{{ baseId }}-notes" translate>Notes</label>
      <textarea
        class="form-control"
        [ngClass]="{ error: showErrors(notesControl, isSubmitted), 'required': isRequired(notesControl) }"
        id="{{ baseId }}-notes"
        [maxlength]="fcListValidation.validations.Notes.MaxLength"
        formControlName="notes"
        rows="3"
      >
      </textarea>
      <div *ngIf="showErrors(notesControl, isSubmitted)" id="{{ baseId }}-warning-text-notes" class="incorrect-input" translate>
        {{ notesControl.errors | fcListValidation : 'Notes' }}
      </div>
    </div>
    <!-- Notes Control -->

    <!-- Inactive and User Defined checkboxes -->
    <div class="checkbox-group">
      <mat-checkbox id="{{ baseId }}-inactive-checkbox" formControlName="inactive" translate> Inactive </mat-checkbox>
      <mat-checkbox id="{{ baseId }}-user-defined-checkbox" formControlName="userDefined" translate> User Defined </mat-checkbox>
    </div>
    <!-- Inactive and User Defined checkboxes -->
  </div>
</fc-general-modal>
